export enum Action {
  Copy = 'copy',
  Move = 'move',
}
